export default function offerParamsOptionsResolver({ offer, on }) {
    return {
        bind: {
            offer,
        },
        on: {
            'change-offer': on.changeOffer,
            'load-grouped-offers': on.loadGroupedOffers,
        },
    };
}
